module.exports = __webpack_public_path__ + "img/largeScreenProgressBgc.1510fa8f.png";